import React from "react";
import {Route, Routes} from "react-router-dom";
import RegGrid from "./registrations/RegGrid";
import RegByOperationGrid from "./operation/RegByOperationGrid";
import RegByWorkerGrid from "./worker/RegByWorkerGrid";
import RegByDnGrid from "./dn/RegByDnGrid";
import RegsByMachineGrid from "./machine/RegsByMachineGrid";
import RegByCustomerGrid from "./customer/RegByCustomerGrid";
import RegCreate from "../registration/RegCreate";


export default () => {

    return <Routes>
        <Route path={"/reg"} element={<RegGrid/>}/>
        <Route path={"/operation"} element={<RegByOperationGrid/>}/>
        <Route path={"/worker"} element={<RegByWorkerGrid/>}/>
        <Route path={"/dn"} element={<RegByDnGrid/>}/>
        <Route path={"/machine"} element={<RegsByMachineGrid/>}/>
        <Route path={"/customer"} element={<RegByCustomerGrid/>}/>
        <Route path={"/create"} element={<RegCreate/>}/>
    </Routes>
}